import {
  Box,
  Button,
  CloseButton,
  Dialog,
  Flex,
  Portal,
  Tag,
  Text,
} from '@chakra-ui/react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import api from '@services/api';

import type { MyDispositionType } from '../types';

type Props = {
  executionId: string;
  list: MyDispositionType[];
  handleClose: () => void;
};

const MyDispositionsDialog = ({ executionId, list, handleClose }: Props) => {
  const navigate = useNavigate();

  const onClickCustomer = async (customerInteractionId: string) => {
    try {
      const response = await api.get(`/campaign_execution/${executionId}/current/${customerInteractionId}`);

      if (response.status === 200) {
        navigate(`/painel/atendimentos/${executionId}/cliente`, {
          state: {
            customer: response.data.customer,
            dispositionId: response.data.id,
          },
        });
      } else {
        toast.error('Erro ao continuar atendimento');
      }
    } catch {
      toast.error('Erro ao continuar atendimento');
    }
  };

  return (
    <Dialog.Root
      size="md"
      placement="center"
      open
      onOpenChange={handleClose}
      closeOnInteractOutside={false}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content bg="grayscale.fg">
            <Dialog.Header>
              <Dialog.Title>
                Atendimentos em andamento
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              {list.map((item) => (
                <Box
                  key={item.id}
                  borderLeft="3px solid"
                  borderColor="border.muted"
                  cursor="pointer"
                  borderRadius={4}
                  bg="bg.muted"
                  overflow="hidden"
                  onClick={() => onClickCustomer(item.id)}
                  mb={4}
                  p={2}
                >
                  <Text textStyle="md" fontWeight={700} mb={1}>
                    {item.customer.name}
                  </Text>
                  {item.customer.tags.length > 0 && (
                    <Flex gap={1} mb={1}>
                      {item.customer.tags.map((tag) => (
                        <Tag.Root key={tag} size="md" bg="argos.fg" color="grayscale" fontWeight={600}>
                          <Tag.Label>{tag}</Tag.Label>
                        </Tag.Root>
                      ))}
                    </Flex>
                  )}
                  <Text textStyle="sm" color="fg.muted">
                    {item.customer.portfolio.name}
                  </Text>
                </Box>
              ))}
            </Dialog.Body>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">Fechar</Button>
              </Dialog.ActionTrigger>
            </Dialog.Footer>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default MyDispositionsDialog;
